// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for performing ChangeLog operations such as persist, discard etc.
 * @see #/components/schemas/ChangeLogRequest - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface ChangeLogRequest {
    /**
     * Unique Encounter id.
     * @dataFormat uuid
     */
    encounter_id: string;
    /**
     * Previous logged in practitioner id.
     * @dataFormat uuid
     */
    previous_user_id: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for ChangeLogRequest
 */
export namespace ChangeLogRequest {
    /**
     * ChangeLogRequest Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Unique Encounter id.
         * @dataFormat uuid
         */
        encounterId: string;
        /**
         * Previous logged in practitioner id.
         * @dataFormat uuid
         */
        previousUserId: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * ChangeLogRequest DTO
     * Transforms ChangeLogRequest model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend ChangeLogRequest model */
        static toModel(obj: ChangeLogRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend ChangeLogRequest model */
        static toApi(obj: Model): ChangeLogRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as ChangeLogRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
